export const UPDATE_GENAI_STATE = 'UPDATE_GENAI_STATE'